import {
  GET_ASSESSMENT_RESULTS,
  ADD_ASSESSMENT_RESULTS,
  CLEAR_ASSESSMENT_RESULTS,
  LOGOUT,
} from "../actions/types";
import api from "../utils/api";
import { loadResultsList, clearAll, loadPMResultsList } from "./admin";
import { setAlert } from "./alerts";

export const getAssessmentByCode = (code) => async (dispatch) => {
  try {
    const res = await api.get(`/assessmentresults/code/${code}/`);
    dispatch({ type: GET_ASSESSMENT_RESULTS, payload: res.data.data });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const getAssessmentById = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/assessmentresults/${id}`);
    dispatch({ type: GET_ASSESSMENT_RESULTS, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getPMAssessmentById = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/assessmentresults/pm/${id}`);
    dispatch({ type: GET_ASSESSMENT_RESULTS, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addAssessmentResult = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/assessmentresults`, formData);
    dispatch({ type: ADD_ASSESSMENT_RESULTS, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addBulkAssessmentResult = (formData) => async (dispatch) => {
  try {
    const res = await api.post(`/assessmentresults/assignment/bulk`, formData);
    if (res.status === 200) {
      // dispatch(loadResultsList(formData?.SchoolID));
      dispatch(setAlert("Assessment assignments completed", "success"));
    }
  } catch (error) {
    const errors = error.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else return errors;
    }
  }
};

export const addBulkPMAssessmentResult =
  (formData) => async (dispatch, getState) => {
    try {
      // Capture existing GoalID/InterventionID for this student BEFORE inserting new results.
      // getState() reads the Redux store synchronously so the data is never stale.
      const pmresultsList = getState().admin.pmresultsList || [];
      // Filter to the SAME chart group (same LevelID + CategoryID) so we don't
      // accidentally inherit a GoalID from a different chart.
      // formData.AssessmentTypeID maps directly to CategoryID in the results.
      const sameGroupResults = pmresultsList.filter(
        (r) =>
          Number(r.LevelID) === Number(formData.LevelID) &&
          Number(r.CategoryID) === Number(formData.AssessmentTypeID),
      );
      const existingRef = sameGroupResults.find(
        (r) => r.GoalID || r.InterventionID,
      );
      const existingGoalID = existingRef?.GoalID || null;
      const existingInterventionID = existingRef?.InterventionID || null;

      const res = await api.post(
        `/assessmentresults/assignment/pmbulk`,
        formData,
      );

      if (res.status === 200) {
        // Link the newly created results to the chart's existing GoalID / InterventionID
        const newResultIDs = res.data.resultIDs;
        if (
          newResultIDs?.length > 0 &&
          (existingGoalID || existingInterventionID)
        ) {
          await api.post("/assessmentresults/pm/results", {
            pmResultIDs: newResultIDs,
            GoalID: existingGoalID,
            InterventionID: existingInterventionID,
          });
        }

        dispatch(loadPMResultsList(formData.StudentID));
        dispatch(setAlert("Assessment assignments completed", "success"));
      }
    } catch (error) {
      const errors = error.response.data.errors;

      if (errors) {
        if (errors[0].msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        } else return errors;
      }
    }
  };

export const updateAssessmentResult = (formData) => async (dispatch) => {
  try {
    await api.put(`/assessmentresults/${formData.ResultID}`, formData);
    // dispatch(loadResultsList(formData.SchoolID));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updatePMAssessmentResult = (formData) => async (dispatch) => {
  try {
    await api.put(`/assessmentresults/pm/${formData.ResultID}`, formData);
    dispatch(loadPMResultsList(formData.StudentID));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const clearAssessmentResult = () => (dispatch) => {
  try {
    dispatch({ type: CLEAR_ASSESSMENT_RESULTS });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};
